import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CreateQuizEventAdapter } from '~analytics/adapters/CreateQuizEventAdapter';
import { useProgress } from '~teacher/hook/utils/useProgress';
import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { importQuizToWorkspaceBySpreadsheet } from '../../../api/workspaces/quiz';

export function useImportQuizToWorkspaceBySpreadsheetMutation() {
  const queryClient = useQueryClient();
  const { progressPercent, onProgressEvent } = useProgress();

  const mutation = useMutation({
    mutationFn: importQuizToWorkspaceBySpreadsheet(onProgressEvent),

    onSettled: async (_data, _error, { workspaceId }) => {
      return Promise.all([
        queryClient.invalidateQueries(workspaceKeys.allQuizzes(workspaceId)),
        queryClient.invalidateQueries(workspaceKeys.list()),
      ]);
    },
    onSuccess: (_data, { workspaceId }) => {
      new CreateQuizEventAdapter({
        creation_method: 'excel',
        source_workspace_id: workspaceId,
        destination_workspace_id: workspaceId,
      }).sendAnalytics();
    },
  });

  return { ...mutation, progressPercent };
}
